import Back from '../../../../assets/icons/back_arrow_grey.svg';

const Header: React.FC = () => {
  return (
    <div className="flex flex-col justify-center items-start">
      <div className="flex flex-col w-full max-w-md">
        <div className="flex items-center">
          <button className="mr-4">
            <img
              src={Back}
              alt="Back"
              className="h-6"
              onClick={() => history.back()}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
export default Header;
